import * as React from "react";
import { DatePicker } from "antd";
import ptBrLocale from "antd/es/date-picker/locale/pt_BR";
import { HiArrowLongRight } from "react-icons/hi2";
import { FaRegCalendarAlt } from "react-icons/fa";
import { CustomLabel } from "../input/CustomLabel";
import { Controller, Control, UseFormRegister, UseFormSetValue } from "react-hook-form";
import { InputErrorMessage } from "../input/InputErrorMessage";
type DateRangePickerWithoutValidationProps = {
  usarValidacaoParaFormulario: false;
};

type DateRangePickerWithValidationProps = {
  usarValidacaoParaFormulario: true;
  /**Nome do atributo que será usado no formulario para realizar as validacoes*/
  name: string;
  register: UseFormRegister<any>;
  control: Control<any>;
  setValue: UseFormSetValue<any>;
  style?: React.CSSProperties;
};

type DateRangePickerProps = {
  id: string;
  label?: string;
  disabled?: boolean;
  className?: string;
  onChange?: (datas: (Date | undefined)[]) => void;
  onClear?: () => void;
  style?: React.CSSProperties;
} & (DateRangePickerWithoutValidationProps | DateRangePickerWithValidationProps);

export const DateRangePicker: React.FC<DateRangePickerProps> = (props) => {
  const renderDateRangePickerComValidacao = (): React.ReactNode => {
    if (props.usarValidacaoParaFormulario) {
      return (
        <Controller
          name={props.name}
          control={props.control}
          render={({ field, fieldState }) => (
            <>
              {props.label && <CustomLabel possuiErro={fieldState.error != null}>{props.label}</CustomLabel>}
              <DatePicker.RangePicker
                {...props.register(props.name)}
                {...field}
                id={props.id}
                allowClear={true}
                locale={ptBrLocale}
                style={{ ...props.style }}
                format="DD/MM/YYYY"
                disabled={props.disabled}
                onChange={(datas) => {
                  field.onChange(datas);
                  props.setValue(props.name, datas);
                  field.value = datas;
                  if (datas?.length === 2) {
                    props.onChange && props.onChange(datas.map((data) => data?.toDate()));
                  } else if (datas === null) {
                    props.onClear && props.onClear();
                  }
                }}
                separator={<HiArrowLongRight color="#757575" />}
                suffixIcon={<FaRegCalendarAlt color="gray" />}
                status={fieldState.error != null ? "error" : ""}
              />
              {fieldState.error && <InputErrorMessage>{fieldState.error.message}</InputErrorMessage>}
            </>
          )}
        />
      );
    }
  };

  const renderDateRangePickerSemValidacao = () => {
    return (
      <>
        {props.label && <CustomLabel possuiErro={false}>{props.label}</CustomLabel>}
        <DatePicker.RangePicker
          id={props.id}
          style={{ cursor: "pointer", borderColor: "#c4c4c4", ...props.style }}
          allowClear={true}
          locale={ptBrLocale}
          format="DD/MM/YYYY"
          disabled={props.disabled}
          onChange={(datas) => {
            if (datas?.length === 2) {
              props.onChange && props.onChange(datas.map((data) => data?.toDate()));
            } else if (datas === null) {
              props.onClear && props.onClear();
            }
          }}
          separator={<HiArrowLongRight color="#757575" />}
          suffixIcon={<FaRegCalendarAlt color="gray" />}
        />
      </>
    );
  };

  return (
    <div className={props.className || ""}>
      {props.usarValidacaoParaFormulario && renderDateRangePickerComValidacao()}
      {!props.usarValidacaoParaFormulario && renderDateRangePickerSemValidacao()}
    </div>
  );
};
